export class GATrackerAdapter {
  constructor(window, document, trackingID) {
    this.window = window
    this.document = document
    this.trackingID = trackingID
  }

  lazyInit() {
    if (this.gaAttributeName) return
    this.gaAttributeName = this.window.GoogleAnalyticsObject || 'ga';
    // this is copied from https://developers.google.com/analytics/devguides/collection/analyticsjs/
    // essentially, it:
    // 1. Creates a function on window called ga if not already there
    // 2. The function lazily initializes the attribute 'q' on itself to an array and
    //    pushes the given arguments into that array
    // 3. Sets the attribute 'l' on the function to the current date
    // 4. Creates a async script element and appends that before any other scripts
    //
    // Left in minified state since it's essentially a library vendored here.
    (function(i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
      }, i[r].l = 1 * new Date()
      a = s.createElement(o),
          m = s.getElementsByTagName(o)[0]
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(this.window, this.document, 'script', 'https://www.google-analytics.com/analytics.js', this.gaAttributeName)
      this.window[this.gaAttributeName]('create', this.trackingID , 'auto', 'tuoReviewWidgetTracker', {
      transport: "beacon"
    })
  }

  trackEvent(category, action, label='', customDimensions={}, callback) {
    this.lazyInit()
    if (typeof(callback) == "function") {
      this.window[this.gaAttributeName]('tuoReviewWidgetTracker.send', 'event', category, action, label, customDimensions, {hitCallback: callback})
    } else {
      this.window[this.gaAttributeName]('tuoReviewWidgetTracker.send', 'event', category, action, label, customDimensions)
    }
  }
}

const gaTrackerAdapter = new GATrackerAdapter(window, document, process.env.VUE_APP_GA_TRACKING_ID)

export default gaTrackerAdapter